import { useEffect, useRef, useState } from "react";
import { getVoiceClip } from "@/lib/voiceClips";
import { meteredAudio } from "@/lib/voiceMeter";
import { aiError } from "./aiError";

// Play one comment in the chosen voice (bars react too); one preview at a time.
export function useCommentPreview(voice) {
  const [preview, setPreview] = useState(null); // { id, state: "loading" | "playing" }
  const audioRef = useRef(null);
  const reqRef = useRef(0);

  const stop = () => { audioRef.current?.pause(); audioRef.current = null; reqRef.current++; setPreview(null); };
  useEffect(() => () => audioRef.current?.pause(), []);

  const toggle = async (c) => {
    if (preview?.id === c.id) { stop(); return; }
    stop();
    if (!c.text.trim()) return;
    const req = reqRef.current;
    setPreview({ id: c.id, state: "loading" });
    let url;
    try { url = await getVoiceClip(c.text, voice); } catch (e) {
      if (req === reqRef.current) setPreview(null);
      await aiError(e, "Couldn't create the voice. Please try again.");
      return;
    }
    if (req !== reqRef.current) return;
    const a = meteredAudio(url);
    audioRef.current = a;
    const end = () => { if (audioRef.current === a) { audioRef.current = null; setPreview(null); } };
    a.onended = end;
    a.onerror = end;
    setPreview({ id: c.id, state: "playing" });
    a.play().catch(end);
  };

  return { preview, togglePreview: toggle, stopPreview: stop };
}
